export default function() {
  if (window['___data']) {
    return require('./store').store;
  } else {
    return {dispatch: () => {}};
  }
}
